import BlogDetailPage from "@/pages/blog/components/BlogDetailPage";

export default function BlogScalableSaaS() {
  return <BlogDetailPage slug="how-to-build-a-scalable-saas-platform" />;
}